module.exports = __webpack_public_path__ + "static/media/googlePin1.bb3f6e64.svg";